import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { BreakoutRoomBlock } from 'components';
import styles from './BreakoutRoomsModal.module.scss';
import { randomInteger, randomWithExclude } from 'helpers/inputFunctions';
import { testName } from 'helpers/filterFunctions';
import { sendToApi, sendToApiReturn } from 'API/teacherCalls';
import { store } from 'storeConfig';
import { updateActivitySection } from 'Redux/actions';
import { letters } from 'helpers/letters';

const BreakoutRoomsModal = ({closeBtn, item, item:{setActiveSection, activeSection}}) => {

  const initialStudents = [...item.students]
  const initialPairs = item.activeSection.rooms
  // const existingRooms = item.activity.sections[item.activeSection.sectionIndex].rooms
  const [ pairs, setPairs] = useState(initialPairs);
  const [ newPairs, setNewPairs] = useState([]);
  const [ selected, setSelected ] = useState([]);
  const [ students, setStudents ] = useState(initialStudents);
  const [ inputText, setInputText ] = useState('');
  let checks = document.querySelectorAll(".check");
  let studentsArray=[]
  
  const checkArray = (arr, val) =>{
    let result = true
    if(arr){
      arr.forEach(item => {if(item.includes(val)){result=false}})
    }
    return result
}

  useEffect(()=>{
    if(initialStudents){
    setTimeout(()=>{
      initialStudents.forEach(item=>{if(item.writingRoom==='initial'){studentsArray.push(item)}});
      setStudents(studentsArray)
    },10)}
    // eslint-disable-next-line
  },[])
  
  useEffect(()=>{
    setPairs(initialPairs)
    // eslint-disable-next-line
  },[useSelector(state=>state.activityData.sections[item.activeSection.sectionIndex].rooms)])
  
  useEffect(()=>{
    setStudents(initialStudents)
    // eslint-disable-next-line
  },[useSelector(state=>state.activityData.sections[item.activeSection.sectionIndex].entries)])

  const selectiveCheck = () => {
    let checkedChecks = document.querySelectorAll(".check:checked");
    if(checks.length>3){
    if (checkedChecks.length > 2)
      return false;
    }
  }

  const handleCheckbox = (e) => {
    
    if(selected.includes(parseInt(e.target.value))){
      const index = selected.indexOf(parseInt(e.target.value))
      let selectedCopy=[...selected];
      selectedCopy.splice(index, 1);
      setSelected(selectedCopy)
    }else{
      if(checks.length>3){if(selected.length>=2){return}}
      setSelected([...selected, parseInt(e.target.value)])
    }
  }

  const handlePair = () => {
    if(selected.length<2){return}
    let studentsCopy = [...students];
    
    selected.forEach(item => {
      const sIndex = studentsCopy.findIndex(student => student.studentId === parseInt(item))
      studentsCopy.splice(sIndex, 1)
    })
    
    checks.forEach(item => item.checked=false);
    setNewPairs([...newPairs, selected])
    setSelected([])
    setStudents(studentsCopy)
  }

  const handleRandom = () => {
    let checksCopy = Array.from(document.querySelectorAll(".check"));
    if(checksCopy.length<2){return}
    setSelected([])
    checks.forEach(item => item.checked=false);

    setTimeout(()=>{
      const num1 = randomInteger(0, checksCopy.length-1);
      checksCopy[num1].click();

      const num2 = randomWithExclude(0, checksCopy.length-1, [num1]);
      checksCopy[num2].click();

      checksCopy.splice(num1, 1);
      checksCopy.splice(num2, 1);

    },100)

  }

  const handleRemove = async (index, studentOne, studentTwo, studentThree, confirmed) => {


    let newArr = confirmed ? [...pairs] : [...newPairs] 
    newArr.splice(index, 1)
  
    if(confirmed){
      const res = await sendToApiReturn(`activity/${item.activity.activityId}/rooms/${item.activeSection.sectionIndex}`, {rooms:newArr})
      setStudents(res.entries)
      setPairs(res.rooms)
      setActiveSection(res)

    } else{
      
      let studentsCopy = [...students]

      studentsCopy.push(studentOne)
      studentsCopy.push(studentTwo)

      if(studentThree){
        studentsCopy.push(studentThree) 
      }

      setNewPairs( newArr );
      setStudents(studentsCopy)
    }
    
    setSelected([])
  }

  const handleCancel = () => {

      for(let i = 0; i<newPairs.length; i++){
        setTimeout(()=>{ document.querySelector('.deleteDraft').click()},10)
      }
  }


  const handleSubmit = async () => {

    if(newPairs.length===0){return}
    setNewPairs([])
    setPairs([...pairs, ...newPairs])
    const data = await sendToApiReturn(`activity/${item.activity.activityId}/rooms/${item.activeSection.sectionIndex}`, {rooms:[...pairs, ...newPairs]})
    setActiveSection(data)

    // store.dispatch(updateActivitySection(item.activeSection.sectionIndex, data))
    
    // //remove paired students from activeSection object to avoid duplication on table 
  }

  for (var i = 0; i < checks.length; i++) checks[i].onclick = selectiveCheck;


    return (
      <div className={styles.container}>
        <div className={styles.left}>
          {/* <h5>{item.activeSection.sectionIndex}</h5> */}
          <h2>Pick Students</h2>
          <h4>Select student to pair them</h4>
          <input type="text" className={styles.studentSearch} onChange={(e)=>{setInputText(e.target.value)}} onFocus={()=>{sendToApi(`activity/${item.activity.activityId}/rooms/${item.activeSection.sectionIndex}`, {rooms:[[],[]]})}}/>
          <div className={styles.buttons}>
            <div onClick={handleRandom} className={styles.btn}>Randomize</div>
            <div onClick={handlePair} className={(selected.length<2 ? `${styles.btn} ${styles.disabled}` : styles.btn)}>Pair them</div>
          </div>
          <div className={styles.students} onChange={(e)=>{handleCheckbox(e)}}>
            {students.map((student, index) =>{
              if(testName(student, inputText) && checkArray(pairs, student.studentId)){
              // if(testName(student, inputText)){
              return(
                <div className={styles.studentDiv}>
                  <input id={`checkbox${index}`} type="checkbox" value={student.studentId} class='check' />
                  <label for={`checkbox${index}`} key={index}>
                    <img src={student.studentBoomerUrl} alt={`${student.studentName} boomer`}/>
                    <p> {student.studentName} </p>
                </label>
                </div>
              )
              }else{return null}
            })}
          </div>
        </div>

        <div className={styles.right}>
          {/* <div>
            <p>activity: {item.activity.activityName}</p>
            <p>section: {item.activeSection.sectionIndex}</p>
          </div> */}
          {pairs?
            pairs.map((room, index)=> {
              if(room){
                return(
                  <BreakoutRoomBlock
                    groupLetter={letters[index]} 
                    key={index} 
                    studentOne={item.students.find(s=>s.studentId===room[0])}
                    studentTwo={item.students.find(s=>s.studentId===room[1])}
                    studentThree={item.students.find(s=>s.studentId===room[2])}
                    students={item.students}
                    index={index}
                    removeIndex={index}
                    handleRemove={handleRemove}
                    item={item}
                    section={{...item.section, rooms:pairs}}
                    setActiveSection={setActiveSection}
                    confirmed={true}
                  />
                )
              }else{return null}
            })
          :null}
          {
            newPairs.map((room, index)=> {
              return(
                <BreakoutRoomBlock
                  groupLetter={letters[index + pairs.length]} 
                  key={index} 
                  studentOne={item.students.find(s=>s.studentId===room[0])}
                  studentTwo={item.students.find(s=>s.studentId===room[1])}
                  studentThree={item.students.find(s=>s.studentId===room[2])} 
                  students={item.students}
                  index={pairs.length + index}
                  removeIndex={index}
                  handleRemove={handleRemove}
                  item={item}
                  section={{...item.section, rooms:pairs}}
                  setActiveSection={setActiveSection}
                  confirmed={false}
                />
              )
            })
          }
        </div>

        <div className={styles.bottomBtns}>
          {
            newPairs.length>0 ?
              <div onClick={handleCancel} className={(newPairs.length ? styles.btn : `${styles.btn} ${styles.disabled}`)}>Cancel</div>
            :
              <div onClick={()=>{closeBtn.current.click()}} className={styles.btn}>close</div>
          }
          <div onClick={handleSubmit} className={(newPairs.length>0 ? styles.btn : `${styles.btn} ${styles.disabled}`)}>Save</div>
        </div>
      </div>
    )

}

export default BreakoutRoomsModal;